import { Component } from 'react';
import {
  Box,
  Heading,
  Container,
  Stack,
  Card,
  CardBody,
} from '@chakra-ui/react';

const loadingTexts = [
  'Turning pages',
  'Rummaging the library',
  'Searching and searching',
]
interface LoadingPageProps {
  loadingText?: string;
}

class LoadingPage extends Component<LoadingPageProps> {
  static defaultProps: LoadingPageProps = {
    loadingText: loadingTexts[Math.floor(Math.random() * loadingTexts.length)],
  };

  renderLoadingPage = () => {
    const { loadingText } = this.props;

    return (
      <>
        <Container maxW={'2xl'} pt={10}>
          <Card style={{ borderRadius: 25 }}>
            <CardBody>
              <Stack as={Box} textAlign={'center'}>
                <Heading
                  fontWeight={500}
                  fontSize={{ base: 'lg', sm: 'xl', md: '2xl' }}
                  lineHeight={'100%'}
                >
                  {loadingText} <br />
                </Heading>
                <img src={'/assets/images/loader.gif'} alt="Loading" />
              </Stack>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  };

  render() {
    return <div>{this.renderLoadingPage()}</div>;
  }
}

export default LoadingPage;
